export default "__VITE_ASSET__9eb31548__"